import { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import S from './MainStyles';
import routesConfig from '../../../router/RoutesConfig';
import useGetFleetId from '../../../API/hooks/useGetFleetId';
import useGetFleet from '../../../API/hooks/useGetFleetDetails';
import globalStore from '../../../store/GlobalStore';

function Main(): JSX.Element {
  const routes = useRoutes(routesConfig);

  const fleetId = useGetFleetId();
  const { data: fleetData } = useGetFleet(fleetId);
  useEffect(() => globalStore.setTimezoneOffset(fleetData?.settings.timezoneOffset), [fleetData]);

  return (
    <S.Wrapper>
      <div className="content-container">{routes}</div>
    </S.Wrapper>
  );
}

export default Main;
